var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4973_540)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.6254 1.71094H14.0133C14.7202 1.71094 15.2933 2.28401 15.2933 2.99094V14.3489C15.2933 15.0559 14.7202 15.6289 14.0133 15.6289H1.98801C1.28108 15.6289 0.708008 15.0558 0.708008 14.3489V2.99094C0.708008 2.28401 1.28108 1.71094 1.98801 1.71094H3.36557M11.3338 1.71094H4.68916",
    stroke: "currentColor",
    strokeWidth: 0.745195
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.433838 4.66602L15.5449 4.66601",
    stroke: "currentColor",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3733 0.655C11.3733 0.50036 11.4987 0.375 11.6533 0.375H12.345C12.4996 0.375 12.625 0.50036 12.625 0.655V2.75906C12.625 2.9137 12.4996 3.03906 12.345 3.03906H11.6533C11.4987 3.03906 11.3733 2.9137 11.3733 2.75906V0.655Z",
    stroke: "currentColor",
    strokeWidth: 0.745195,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.37158 0.655C3.37158 0.50036 3.49694 0.375 3.65158 0.375H4.34329C4.49793 0.375 4.62329 0.50036 4.62329 0.655V2.75906C4.62329 2.9137 4.49793 3.03906 4.34329 3.03906H3.65158C3.49694 3.03906 3.37158 2.9137 3.37158 2.75906V0.655Z",
    stroke: "currentColor",
    strokeWidth: 0.745195,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.6672,
    y: 6.99609,
    width: 1.67,
    height: 1.67,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.33228,
    y: 6.99609,
    width: 1.67,
    height: 1.67,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5.99731,
    y: 6.99609,
    width: 1.67,
    height: 1.67,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.66235,
    y: 6.99609,
    width: 1.67,
    height: 1.67,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.6672,
    y: 9.33447,
    width: 1.67,
    height: 1.67,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.33228,
    y: 9.33447,
    width: 1.67,
    height: 1.67,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5.99731,
    y: 9.33447,
    width: 1.67,
    height: 1.67,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.66235,
    y: 9.33447,
    width: 1.67,
    height: 1.67,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.6672,
    y: 11.6626,
    width: 1.67,
    height: 1.67,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.33228,
    y: 11.6626,
    width: 1.67,
    height: 1.67,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5.99731,
    y: 11.6626,
    width: 1.67,
    height: 1.67,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.66235,
    y: 11.6626,
    width: 1.67,
    height: 1.67,
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4973_540"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarOutline);
export default __webpack_public_path__ + "static/media/calendar-outline.6c371e65614a65b087dd62275d73d1a2.svg";
export { ForwardRef as ReactComponent };